module.exports = __webpack_public_path__ + "static/section1-5cea726c8bb34c8ee90fea2843b08f2f.png";